import { render, staticRenderFns } from "./EditGeneralSetting.vue?vue&type=template&id=264b02ed&"
import script from "./EditGeneralSetting.vue?vue&type=script&lang=js&"
export * from "./EditGeneralSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports